import {Component, ViewChild, ViewEncapsulation} from '@angular/core';
import {StateService} from "../../service/state";
import {FormularComponent} from "../../components/login/formular/formular.component";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material";
import {PayPalDialog} from "../../components/checkout/dialog/paypal/paypal.component";
import {AdvanceDialog} from "../../components/checkout/dialog/advance/advance.component";
import {CartService} from "../../service/cart";
import {ApiService} from "../../service/api";
import {PickupDialog} from "../../components/checkout/dialog/pickup/pickup.component";
import {MediaMatcher} from "@angular/cdk/layout";

@Component({
    selector: 'app-checkout',
    templateUrl: './checkout.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent {
    public activeTab: number = 0;
    public loggedIn: boolean = false;

    public firstname: string;
    public surname: string;

    public address: any;
    public payment: any;
    public message: string;
    public mobileQuery: MediaQueryList;
    @ViewChild('loginform')
    public loginform: FormularComponent;

    constructor(public api: ApiService, public state: StateService, public cart: CartService,
                public dialog: MatDialog, public router: Router, public routeParams: ActivatedRoute,
                public media: MediaMatcher) {
        this.mobileQuery = media.matchMedia('(max-width: 768px)');
        routeParams.params.subscribe(params => {
            if (params.hasOwnProperty('step')) {
                this.activeTab = params['step'];
            } else {
                this.activeTab = 0;
            }

            if (!this.payment && this.activeTab > 3) {
                this.router.navigate(['checkout', 3]);
            }

            if (!this.address && this.activeTab > 2) {
                this.router.navigate(['checkout', 2]);
            }
        });

        this.state.getState('user').then((user) => {
            if (user) {
                this.loggedIn = true;
                this.firstname = user.firstname;
                this.surname = user.surname;
            } else {
                this.loggedIn = false;
            }
        })

        this.state.watchState('user').subscribe((user) => {
            if (user) {
                this.loggedIn = true;
            } else {
                this.loggedIn = false;
            }
        })
    }

    public onLogin($event): void {
        if ($event)
            this.next();
    }

    public next(): void {
        if (this.cart.getItems().length == 0) {
            this.router.navigate(['home']);
            return;
        }
        let at = +this.activeTab + 1;
        if (at == 1 && this.loggedIn) {
            at = at + 1;
        }
        if (this.address && this.address.country) {
            this.cart.shipment = this.address.country;
        }

        this.router.navigate(['checkout', at]);
    }

    public pay(): void {
        if (this.cart.getItems().length == 0) {
            this.router.navigate(['home']);
            return;
        }

        // Payment Hook
        // Dialog mit Payment anzeigen (Info oder Paypal Dialog)

        let subtotal = this.cart.getTotalPrice(false, false),
            shipping = this.cart.getShippingPrice(null),
            handling_fee = Math.round((this.payment.fee > 0 ? ((subtotal + shipping) / 100 * this.payment.fee) : 0) * 100) / 100,
            total = Math.round(((subtotal + shipping + handling_fee) * 100)) / 100,
            data_total = {
                subtotal: subtotal,
                shipping: shipping,
                handling_fee: handling_fee,
                total: total
            };


        this.api.call('/checkout/index/checkout', {
            payment: this.payment,
            address: this.address,
            cart: this.cart.getItems(),
            total: data_total,
            message: this.message
        }).then((result) => {
            this.cart.clear();

            if (this.payment.id == 'paypal') {
                this.dialog.open(PayPalDialog, {
                    data: {
                        payment: this.payment,
                        address: this.address,
                        total: data_total,
                        purchase: result
                    }
                });
            } else if (this.payment.id == 'advance') {
                this.dialog.open(AdvanceDialog, {
                    data: {
                        payment: this.payment,
                        address: this.address,
                        total: data_total,
                        purchase: result
                    }
                });
            } else {
                this.dialog.open(PickupDialog, {
                    data: {
                        payment: this.payment,
                        address: this.address,
                        total: data_total,
                        purchase: result
                    }
                });
            }

            this.next();
        })
    }

    public previous(): void {
        let at = this.activeTab - 1;
        if (at == 1 && this.loggedIn) {
            at = at - 1;
        }
        this.router.navigate(['checkout', at]);
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/checkout/checkout.component.ts